module.exports = __webpack_public_path__ + "static/media/telegramIcon.eb368e5a.svg";